/*
	Holds promises of page feature requests for cases where functionality must
	wait for any oustanding feature requests to load.

	Page features that are involved are added to this common array, so that the
	suspended functionality can wait for all to complete (Promise.all)

	Use Case: In-page anchors that scroll the user down to a section on the page,
	crossing paths where features are not yet loaded. In order to scroll to the
	correct offset, those features may need to load (affecting the document layout)
	to calculate the correct offset.

	Use Case: Inbound URL with an in-page anchor. The otherwise lazy loaded page
	features must be loaded immediately along with page load in the presence of a
	hash in (document.location.hash) so that the page can jump to the correct
	offset on the page, on page load.

*/
const lazyPageFeatureRequests: Array<Promise<any>> = [];

export default lazyPageFeatureRequests;
